import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminAnalytics = lazy(() => import("@/pages/admin/AdminAnalytics"));

export const Route = createFileRoute("/admin/analytics")({
  component: AdminAnalytics,
});
